export default {
  toasts: {
    load_error: 'Configurarea plăților nu a putut fi încărcată',
    rails_saved: 'Canalele de plată au fost salvate',
    gateway_registered: 'Poartă de plată înregistrată',
    redact_failed: 'Poarta de plată nu a putut fi redactată',
    gateway_redacted: 'Poartă de plată redactată',
    sca_provisioned: 'Înregistrare 3DS2 creată',
    company_assigned: 'Restaurant alocat',
    default_set: 'Poarta implicită a fost setată — restaurantele noi vor fi alocate acesteia automat',
    default_failed: 'Poarta implicită nu a putut fi setată',
    primary_switched: 'Poarta principală a fost comutată la {{gateway}}',
    primary_switch_failed: 'Poarta principală nu a putut fi comutată',
  },
  custody: {
    title: 'Cine procesează plățile',
    description:
      'Decis o singură dată, la prima salvare a railului, și blocat ulterior: cu propriul gateway partenerul deține fondurile; pe contul Adyen FoodAmigos, FoodAmigos le deține și plătește lunar cota partenerului.',
    options: {
      provider: 'Gateway-ul propriu al partenerului',
      platform: 'FoodAmigos procesează plățile',
    },
    locked_notice: 'Blocat la „{{custodian}}” de configurarea plăților — nu poate fi schimbat.',
    pick_first: 'Alegeți mai întâi cine procesează plățile.',
    lock_confirm: {
      title: 'Blocați plățile la „{{custodian}}”?',
      description:
        'Salvarea acum stabilește cine deține fondurile acestui partener, iar acest lucru nu poate fi anulat — nici aici, nici de suport. Canalul de plată poate fi schimbat ulterior; cine procesează plățile nu poate.',
      confirm: 'Blocați și salvați',
    },
  },
  rails: {
    title: 'Canal de plată',
    description:
      'Ce procesator folosește acest partener — unul singur odată. Restaurantele pot fi comutate doar la canalul selectat aici, iar un canal nu poate fi înlocuit cât timp restaurantele încă taxează pe el.',
    save: 'Salvează canalul',
    multiple_warning:
      'Acest partener încă folosește mai multe canale ({{rails}}). Salvarea păstrează doar pe cel selectat mai sus; restul sunt eliminate, iar modificarea este refuzată dacă vreun restaurant încă taxează pe unul dintre ele.',
    options: {
      stripe: 'Stripe',
      adyen: 'Adyen',
      spreedly: 'Poartă locală prin Spreedly',
    },
    platform_stripe_unavailable: 'Stripe pe conturile FoodAmigos nu este încă disponibil.',
    platform_custody_notice: 'Nu este disponibil când FoodAmigos procesează plățile.',
    provider_custody_adyen_notice:
      'Nu este disponibil când partenerul își aduce propriul procesator — Adyen este platforma de procesare FoodAmigos.',
  },
  spreedly_section_title: 'Configurare Spreedly',
  gateways: {
    title: 'Porți de plată',
    description:
      'Conturile PSP proprii ale partenerului. Întreaga debitare este decontată la acceptantul porții selectate.',
    register: 'Înregistrează poarta',
    empty: 'Nicio poartă înregistrată încă',
    columns: {
      gateway: 'Poartă',
      status: 'Stare',
      sca: '3DS2',
      companies: 'Restaurante',
    },
    statuses: {
      active: 'Activ',
      redacted: 'Redactat',
    },
    sca: {
      sandbox: '3DS2 sandbox',
      live: '3DS2 live',
      none: 'Fără 3DS2',
    },
    default_tag: 'Implicit',
    actions: {
      make_default: 'Setează ca implicit',
      check: 'Rulează verificarea…',
      sca_provision: 'Configurează 3DS2…',
      sca_manage: 'Înregistrare 3DS2…',
      redact: 'Redactează poarta',
    },
  },
  redact_confirm: {
    title: 'Redactezi {{gateway}}?',
    description:
      'Datele de autentificare sunt șterse la Spreedly și nu pot fi restaurate. {{count}} restaurant(e) alocat(e) încă debitează prin această poartă — cât timp există restaurante alocate, redactarea este refuzată și vi se cere să confirmați din nou.',
    redact: 'Redactează',
    force_title: 'Redactezi {{gateway}} totuși?',
    force_description:
      '{{count}} restaurant(e) sunt încă alocate acestei porți. Redactarea acum va refuza finalizarea comenzii pentru acestea până când fiecare este alocat unei alte porți. Această acțiune nu poate fi anulată.',
    force_redact: 'Redactează totuși',
  },
  companies: {
    title: 'Restaurante',
    description: 'Procesatorul prin care debitează fiecare restaurant și alocarea sa de poartă Spreedly.',
    empty: 'Niciun restaurant',
    no_gateway: 'Niciuna',
    unassigned: 'Nealocat',
    // The default gateway is assigned at creation and never fails the creation —
    // so a restaurant can end up unassigned with the reason only in the log.
    assignment_error_label: 'Alocarea automată a eșuat',
    assign: 'Alocă',
    reassign: 'Realocă',
    columns: {
      restaurant: 'Restaurant',
      primary_gateway: 'Poarta principală',
      spreedly: 'Poarta Spreedly',
    },
    switch_primary_to: 'Comută la {{gateway}}',
    assign_modal: {
      title: 'Alocă {{company}} unei porți',
      assign: 'Alocă',
      gateway: 'Poartă',
      make_primary: 'Setează și Spreedly ca poartă principală',
      make_primary_hint: 'Debitările se rutează prin Spreedly doar cât timp este poarta principală.',
    },
  },
  register_modal: {
    title: 'Înregistrează o poartă',
    register: 'Înregistrează',
    gateway_type: 'Tip de poartă',
    gateway_type_placeholder: 'Căutare în catalogul Spreedly…',
    auth_mode: 'Mod de autentificare',
    no_credentials: 'Acest tip de poartă nu necesită date de autentificare (Spreedly sandbox).',
    description: 'Descriere',
    description_placeholder: 'ex. Acme Eats — Braintree EUR',
    acquirer_merchant_id: 'ID comerciant acceptant',
    acquirer_hint: 'Opțional — necesar împreună cu MCC',
    mcc: 'MCC',
    mcc_hint: '4 cifre, ex. 5812',
    make_default: 'Folosește ca implicit al partenerului',
    make_default_hint:
      'Restaurantele noi ale partenerului și cele fără gateway sunt fixate pe acesta. Lasă necompletat dacă este acquirerul propriu al unui singur restaurant.',
  },
  sca_modal: {
    title: 'Înregistrare 3DS2 — {{gateway}}',
    provision: 'Provizionează',
    irreversible_warning:
      'Ireversibil: nici profilul comerciantului, nici furnizorul SCA nu pot fi editate sau șterse ulterior. Un BIN de acceptant greșit apare doar la momentul debitării. Verificați toate valorile cu banca acceptantă înainte de provizionare.',
    already_provisioned:
      'Deja provizionat (token furnizor {{token}}). Provizionarea din nou returnează înregistrarea existentă, cu excepția cazului în care este activată opțiunea Recreează.',
    type: {
      label: 'Tip furnizor',
      hint: '„Test” simulează rezultatele autentificării și este respins în producție.',
      test: 'Test (SCA sandbox)',
      live: 'Live (Spreedly 3DS2 Global)',
    },
    country: {
      hint: 'Țara sub care banca achizitoare a înregistrat acest comerciant — nu neapărat cea în care este înregistrat partenerul. Se aplică fiecărei rețele de card de mai jos.',
      differs_warning:
        'Aceasta nu este țara partenerului ({{country}}). Corectați dacă acceptatorul a înregistrat comerciantul în altă parte; altfel verificați, deoarece un profil de comerciant nu poate fi editat după creare.',
    },
    network_placeholder: 'Rețea de card',
    add_network: 'Adaugă rețea de card',
    networks: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners',
      jcb: 'JCB',
      dankort: 'Dankort',
      union_pay: 'UnionPay',
      cartes_bancaires: 'Cartes Bancaires',
    },
    fields: {
      acquirer_merchant_id: 'ID comerciant acceptant',
      acquirer_bin: 'BIN achizitor',
      mcc: 'MCC',
      merchant_name: 'Nume comerciant',
      country_code: 'Țară (ISO-2)',
      merchant_url: 'URL comerciant',
    },
    recreate: {
      label: 'Recreează înregistrarea',
      hint: 'Abandonează definitiv profilul de comerciant și furnizorul SCA actuale și creează altele noi.',
    },
  },
  check_modal: {
    title: 'Verifică poarta de plată — {{gateway}}',
    run: 'Rulează verificarea',
    done: 'Finalizat',
    failed: 'Verificarea nu a putut fi rulată.',
    types: {
      verify: 'Verificare (fără mișcări de bani)',
      test_payment: 'Plată de test',
    },
    verify_unsupported: 'Acest tip de poartă de plată nu suportă verificarea — rulează o plată de test.',
    test_payment_warning:
      'Se efectuează o încasare reală pe o poartă live, rambursată imediat. Pe porțile din piețele SCA, emitentul poate refuza testul non-3DS — asta dovedește totuși că datele au ajuns la achizitor.',
    amount: 'Sumă',
    amount_help: 'Între 1.00 și 5.00',
    check_passed: 'Verificare reușită',
    check_failed: 'Verificare eșuată — vezi pașii de mai jos',
    legs: {
      verify: 'Verificare',
      purchase: 'Încasare',
      credit: 'Rambursare',
    },
    leg_passed: 'Reușit',
    leg_failed: 'Eșuat',
  },
  card_fields: {
    script_failed: 'Scriptul Spreedly nu a putut fi încărcat. Verifică rețeaua și încearcă din nou.',
    full_name: 'Nume titular card',
    number: 'Număr card',
    expiry: 'Expirare',
    cvv: 'CVV',
  },
};
